export const COMPANY_SIZE_OPTIONS = [
  { value: '1-10', label: '1 - 10' },
  { value: '11-50', label: '11 - 50' },
  { value: '51-200', label: '51 - 200' },
  { value: '201-500', label: '201 - 500' },
  { value: '500+', label: '500+' },
];

export const INDUSTRY_OPTIONS = [
  {
    value: 'Aerospace & Defense',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.AEROSPACE_DEFENSE',
  },
  {
    value: 'Agriculture & Food',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.AGRICULTURE_FOOD',
  },
  {
    value: 'Automotive & Transportation',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.AUTOMOTIVE_TRANSPORTATION',
  },
  {
    value: 'Chemicals & Materials',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.CHEMICALS_MATERIALS',
  },
  {
    value: 'Construction & Built Environment',
    labelKey:
      'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.CONSTRUCTION_BUILT_ENVIRONMENT',
  },
  {
    value: 'Consumer Packaged Goods (CPG)',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.CONSUMER_PACKAGED_GOODS',
  },
  {
    value: 'Education',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.EDUCATION',
  },
  {
    value: 'Entertainment',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.ENTERTAINMENT',
  },
  { value: 'Finance', labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.FINANCE' },
  {
    value: 'Government & Nonprofit',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.GOVERNMENT_NONPROFIT',
  },
  {
    value: 'Healthcare',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.HEALTHCARE',
  },
  {
    value: 'Hospitality & Tourism',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.HOSPITALITY_TOURISM',
  },
  {
    value: 'Industrial & Energy',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.INDUSTRIAL_ENERGY',
  },
  {
    value: 'Legal & Compliance',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.LEGAL_COMPLIANCE',
  },
  {
    value: 'Lifestyle & Leisure',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.LIFESTYLE_LEISURE',
  },
  {
    value: 'Logistics & Supply Chain',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.LOGISTICS_SUPPLY_CHAIN',
  },
  {
    value: 'Luxury & Fashion',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.LUXURY_FASHION',
  },
  {
    value: 'News & Media',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.NEWS_MEDIA',
  },
  {
    value: 'Professional Services & Agencies',
    labelKey:
      'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.PROFESSIONAL_SERVICES_AGENCIES',
  },
  {
    value: 'Real Estate & PropTech',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.REAL_ESTATE_PROPTECH',
  },
  {
    value: 'Retail & E-commerce',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.RETAIL_ECOMMERCE',
  },
  { value: 'Sports', labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.SPORTS' },
  {
    value: 'Technology',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.TECHNOLOGY',
  },
  {
    value: 'Telecommunications',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.TELECOMMUNICATIONS',
  },
  { value: 'Other', labelKey: 'ONBOARDING_NEXT.OPTIONS.INDUSTRIES.OTHER' },
];

export const REFERRAL_SOURCE_OPTIONS = [
  {
    value: 'google',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.REFERRAL_SOURCES.GOOGLE',
  },
  {
    value: 'reddit',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.REFERRAL_SOURCES.REDDIT',
  },
  {
    value: 'twitter',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.REFERRAL_SOURCES.TWITTER',
  },
  {
    value: 'linkedin',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.REFERRAL_SOURCES.LINKEDIN',
  },
  {
    value: 'friend',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.REFERRAL_SOURCES.FRIEND',
  },
  { value: 'blog', labelKey: 'ONBOARDING_NEXT.OPTIONS.REFERRAL_SOURCES.BLOG' },
  {
    value: 'github',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.REFERRAL_SOURCES.GITHUB',
  },
  {
    value: 'other',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.REFERRAL_SOURCES.OTHER',
  },
];

export const USER_ROLE_OPTIONS = [
  { value: 'founder', labelKey: 'ONBOARDING_NEXT.OPTIONS.USER_ROLES.FOUNDER' },
  {
    value: 'product_manager',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.USER_ROLES.PRODUCT_MANAGER',
  },
  {
    value: 'engineering',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.USER_ROLES.ENGINEERING',
  },
  {
    value: 'support_lead',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.USER_ROLES.SUPPORT_LEAD',
  },
  {
    value: 'marketing',
    labelKey: 'ONBOARDING_NEXT.OPTIONS.USER_ROLES.MARKETING',
  },
  { value: 'sales', labelKey: 'ONBOARDING_NEXT.OPTIONS.USER_ROLES.SALES' },
  { value: 'other', labelKey: 'ONBOARDING_NEXT.OPTIONS.USER_ROLES.OTHER' },
];

export const translateOptions = (options, translate) =>
  options.map(({ labelKey, ...option }) => ({
    ...option,
    label: translate(labelKey),
  }));
